export default __webpack_public_path__ + "static/media/sonakontekstis_en.76c78cb3.png";